import { Hash } from 'lucide-react';

interface AutoNumberValue {
  prefix?: string;
  number: number;
}

interface AutoNumberCellProps {
  value: AutoNumberValue | number | null;
  config?: { prefix?: string; digits?: number };
  readOnly?: boolean;
}

export function AutoNumberCell({ value, config }: AutoNumberCellProps) {
  // Auto Number é sempre read-only
  
  if (!value && value !== 0) {
    return <span className="text-gray-400 text-sm">-</span>;
  }

  let prefix = config?.prefix || '';
  let number = 0;

  if (typeof value === 'number') {
    number = value;
  } else if (value && typeof value === 'object') {
    prefix = value.prefix || prefix;
    number = value.number;
  }

  // Formata com zeros à esquerda
  const digits = config?.digits || 4;
  const formattedNumber = number.toString().padStart(digits, '0');
  const displayValue = prefix ? `${prefix}${formattedNumber}` : formattedNumber;

  return (
    <div className="flex items-center gap-1 text-gray-700 font-mono">
      <Hash className="w-3 h-3 text-gray-500" />
      <span className="font-semibold">{displayValue}</span>
    </div>
  );
}
